import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { cn } from "app/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "app/shadcnComponents/ui/tooltip";

export default function SectionHeader({
  title,
  count,
  countSuffix,
  titleClassName,
  icon,
  id,
  tooltip,
}: Readonly<{
  title: string;
  count: number;
  countSuffix?: string;
  titleClassName?: string;
  icon?: IconDefinition;
  id?: string;
  tooltip?: string;
}>) {
  const countLabel =
    countSuffix || (count === 1 ? "1 person" : `${count} people`);
  return (
    <div
      id={id}
      className="flex items-center justify-between px-6 pt-4 pb-1.5 bg-white"
    >
      <span
        className={cn(
          "text-xs font-semibold uppercase tracking-wider flex items-center gap-1.5",
          titleClassName ?? "text-charcoal-100"
        )}
      >
        {icon && <FontAwesomeIcon icon={icon} className="text-[10px]" />}
        {title}
        {tooltip && (
          <TooltipProvider delayDuration={150}>
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  aria-label={`About ${title}`}
                  className="inline-flex items-center justify-center text-charcoal-60 hover:text-charcoal-100 cursor-help focus:outline-none focus-visible:ring-1 focus-visible:ring-sapphire-60 rounded normal-case"
                >
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    className="text-[14px]"
                  />
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom" align="start" className="w-64">
                {tooltip}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </span>
      <span className="text-xs text-charcoal-60 font-medium">{countLabel}</span>
    </div>
  );
}
